export enum FormSessionTranslKey {
    ACCESSED_AT = "formSession:accessedAt",
    ACCESSED_FROM = "formSession:accessedFrom",
    ACCESSED_THRU = "formSession:accessedThru",
    CONTINUE_TO_FORM = "formSession:continueToForm",
    CONTINUE_WITHOUT_WAITING = "formSession:continueWithoutWaiting",
    DATOVA_SCHRANKA = "formSession:datovaSchranka",
    DETAILS = "formSession:details",
    DOCUMENT_TYPE = "formSession:documentType",
    DOCUMENT_TYPES = "formSession:documentTypes",
    DOCUMENT_VERSION = "formSession:documentVersion",
    EMAIL = "formSession:email",
    FORM_OPENING = "formSession:formOpening",
    FORM_SESSION_LOAD_FAILED_MISSING_DATA = "formSession:formSessionLoadFailedMissingData",
    FORM_SESSION_LOAD_FAILED_TITLE = "formSession:formSessionLoadFailedTitle",
    FORM_SESSIONS_OVERVIEW = "formSession:formSessionsOverview",
    GO_TO_DASHBOARD = "formSession:goToDashboard",
    MISSING_PARAMETERS = "formSession:missingParameters",
    OPTIONAL_PREFILL_INFORMATION_SYSTEMS_DETAIL = "formSession:optionalPrefillInformationSystemsDetail",
    OPTIONAL_PREFILL_INFORMATION_SYSTEMS_TITLE = "formSession:optionalPrefillInformationSystemsTitle",
    PERSON_DATA_RETRIEVAL_DETAIL = "formSession:personDataRetrievalDetail",
    PERSON_DATA_RETRIEVAL_SUCCESS = "formSession:personDataRetrievalSuccess",
    PERSON_DATA_RETRIEVAL_TITLE = "formSession:personDataRetrievalTitle",
    PHONE = "formSession:phone",
    REDIRECT_TO_FORM_IS_NOT_ALLOWED = "formSession:redirectToFormIsNotAllowed",
    REQUIRED_PREFILL_INFORMATION_SYSTEMS_DETAIL = "formSession:requiredPrefillInformationSystemsDetail",
    REQUIRED_PREFILL_INFORMATION_SYSTEMS_TITLE = "formSession:requiredPrefillInformationSystemsTitle",
    REQUIRED_PREFILL_REQUESTS_FAILED = "formSession:requiredPrefillRequestsFailed",
    REQUIRED_PREFILL_REQUESTS_FAILED_DIALOG_MESSAGE = "formSession:requiredPrefillRequestsFailedDialogMessage",
    REQUIRED_PREFILL_REQUESTS_FAILED_DIALOG_TITLE = "formSession:requiredPrefillRequestsFailedDialogTitle",
    USER = "formSession:user",
}
